<template>
  <div class="form-group">
    <label class="form-control-label" :id="'input-text-' + this._uid">
      <slot></slot> <span v-if="required" class="required" data-toggle="tooltip" data-placement="bottom" title="Required">*</span>
      <a href="http://commonmark.org" target="commonmark.org" data-toggle="tooltip" data-placement="bottom" title="Markdown compatible">
        <img src="../../assets/markdown-mark.png" height="11" width="18">
      </a>
    </label>
    <textarea class="form-control"
      :id="'input-text-' + this._uid"
      ref="input"
      :value="value"
      v-on:input="updateValue($event.target.value)"
      :rows="rows"
      :class="{ 'is-invalid': error }"
      :placeholder="placeholder">
    </textarea>
    <small v-if="helpText" class="form-text text-muted">{{helpText}}</small>
    <div v-if="error" class="invalid-feedback">{{ error.message }}</div>
  </div>
</template>
<script>
export default {
  name: "vue-ez-textarea-md",
  props: [
    "value",
    "error",
    "helpText",
    "required",
    "type",
    "disabled",
    "rows",
    "placeholder"
  ],
  mounted() {
    /* eslint-disable no-undef */
    $('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>
